// extracted by mini-css-extract-plugin
export var icon = "links-module--icon--R6Q7h";
export var linkcard = "links-module--linkcard--Vpcqu";
export var linkgroup = "links-module--linkgroup--dmB1J";
export var listgroup = "links-module--listgroup--1YbFt";
export var revised = "links-module--revised--1EEji";